<div class="flex-container">
    <div class="header">
      <div class="header-background"></div>
      <div class="position-relative h-100 w-100">
        <span class="title d-flex justify-content-center align-items-center"><span class="text-color-primary fs-3">{{APP_TITLE}}</span></span>
      </div>
    </div>
    <div class="flex-grow-1 d-flex growing-div">
      <div class="w-100 h-100 d-flex">
        <left-sidebar-menu 
          [sideBarButtonsTop]="leftSideButtonsElements.topButtons"
          [sideBarButtonsBottom]="leftSideButtonsElements.bottomButtons"
        ></left-sidebar-menu>
        <schema-overview [mainComponent]="this"></schema-overview>
        <models-overview [mainComponent]="this"></models-overview>
        <taxonomy-overview [mainComponent]="this"></taxonomy-overview>

        <views-overview 
          [mainComponent]="this"
          [importData]="importData"
        ></views-overview>
        <div
          #dvContainer
          class="flex-grow-1 tabs-container h-100 w-75 position-relative"
          [style.margin-right]="this.rightMenu?.isOverviewActive ? '70px' : '0px'"
          style="transition: margin-right 0.2s;"
        >
          <mat-tab-group class="main-tab" mat-stretch-tabs="false" mat-align-tabs="start" headerPosition="below" (selectedIndexChange)="onTabChange($event)" [(selectedIndex)]="selectedIndex">
            @for (item of tabs; track item.id; let i = $index) {
              <mat-tab #tab [label]="item.label.toString()" class="h-100">
                @switch (item.type) {
                  @case (TabType.VIEW) {
                    <view-visualizer
                      [appComponent]="this"
                      [tabIndex]="i"
                      [agentTabId]="item.id"
                      [containerElement]="dvContainer"
                    ></view-visualizer>
                  }
                  @case (TabType.MODEL_CREATOR) {
                    <neo4j-creator
                      [appComponent]="this"
                      [tabIndex]="i"
                      [agentTabId]="item.id"
                      [containerElement]="dvContainer"
                    ></neo4j-creator>
                  }
                  @case (TabType.METRICS) {
                    <data-viewer
                      [appComponent]="this"
                      [tabIndex]="i"
                      [agentTabId]="item.id"
                      [containerElement]="dvContainer"
                    ></data-viewer>
                  }
                  @case (TabType.SIMULATION) {
                    <simulation-tab
                      [appComponent]="this"
                      [tabIndex]="i"
                      [agentTabId]="item.id"
                      [containerElement]="dvContainer"
                    ></simulation-tab>
                  }
                  @default {
                    <neo4j-creator
                      [appComponent]="this"
                      [tabIndex]="i"
                      [agentTabId]="item.id"
                      [containerElement]="dvContainer"
                    ></neo4j-creator>
                  }
                }
              </mat-tab>
            }
          </mat-tab-group>
          <div 
            class="tabs d-flex align-items-end" 
            [ngClass]="{'justify-content-start': tabs.length >= 10, 'justify-content-center': tabs.length < 10}" 
            id="tabs-container"
          >
            @for(item of tabs; track $index; let i = $index){
              <div
                (contextmenu)="openOnRight($event, i)"
                class="tab-item me-3" (click)="changeTab(i)" [ngClass]="{'selected-tab': selectedIndex === i}"
                [matTooltip]="item.label"
              >
              <!-- <div class="tab-item me-3" (click)="changeTab(i)"> -->
                <p class="text-center w-100 text-truncate">{{item.label}}</p>
                <div class="d-flex justify-content-center align-items-center w-100">
                  <span class="done-icon material-symbols-outlined">task_alt</span>
                  <span class="dataservice-text text-truncate">{{item.dataservice}}</span>
                </div>
              </div>
            }
            <div class="tab-item d-flex justify-content-center align-items-center" (click)="newTabFromStorage()">
              <span class="material-symbols-outlined">add</span>
              <!-- <p class="text-center w-100 m-0">
                {{NEW_TAB}}
              </p> -->
            </div>
          </div>
        </div>
        <right-sidebar-menu 
          #rightMenu
          [sideBarButtonsTop]="rightSideButtonsElements.topButtons"
          [sideBarButtonsBottom]="rightSideButtonsElements.bottomButtons"
        ></right-sidebar-menu>
      </div>
      
    </div>

  <propierties-overview #propiertiesOverview [mainComponent]="this"></propierties-overview>
  <button mat-button [matMenuTriggerFor]="labelMenu" #menuTrigger="matMenuTrigger" style="display: none;"></button>
  <mat-menu #labelMenu="matMenu">
    <button mat-menu-item (click)="closeTab(contextIndex)">Close</button>
    <button mat-menu-item (click)="closeOthers(contextIndex)">Close others</button>
    <button mat-menu-item (click)="closeRight(contextIndex)">Close to the right</button>
  </mat-menu>
</div>
